// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"paragraph_paragraph__QKTes","smallFontSize":"paragraph_smallFontSize__1xVkf","muted":"paragraph_muted__2chp5"};